import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import learning from 'assets/img/marketing-landing/learning.png';
import emailRegex from 'utils/emailRegex';
import FormWithValidations from 'components/form-with-validations';

const marketingPageData = {
  'parents-tips': {
    title: "Is your child really learning what's most needed?",
    subtitle:
      'Sign up for a list of critical questions parents are asking schools.',
    image: learning,
  },
  'parents-info': {
    title: "Is your child <em>really</em> learning what's most needed?",
    subtitle: 'Sign up to receive a list of critical questions to ask.',
    image: learning,
  },
  'teachers-tips': {
    title: 'The proven way to make your work easier and better!',
    subtitle: 'Sign up and get your checklist for true collaborative learning.',
    image: learning,
  },
  'teachers-info': {
    title: 'How teachers just like you are making it happen!',
    subtitle:
      'Sign up and discover how other teachers are successfully juggling all these new responsibilities.',
    image: learning,
  },
};

const validations = {
  name: value => Boolean(value),
  email: value => emailRegex.test(value),
};

class MarketingLanding extends Component {
  componentDidMount() {
    this.props.toggleRegistration();
  }

  componentWillUnmount() {
    this.props.toggleRegistration();
  }

  createHtml(text) {
    return <span dangerouslySetInnerHTML={{ __html: text }} />;
  }

  render() {
    const { type, fields, errors, handleSubmit, handleChange, showForm } =
      this.props;
    const { name, email, school, message } = fields;

    const data = marketingPageData[type];

    return (
      <div className={`${styles.mainContent} row`}>
        <div className={`${styles.heading} col-xs-12 col-sm-12 text-center`}>
          <h2 className={`${styles.titletown}`}>
            {this.createHtml(data.title)}
          </h2>
        </div>
        <div className="col-xs-12 col-sm-6">
          <img className={styles.mainImage} src={data.image} alt="" />
        </div>
        {showForm ? (
          <div className="col-xs-12 col-sm-6">
            <p className={styles.subtitle}>{this.createHtml(data.subtitle)}</p>
            <form className={styles.landingForm} onSubmit={handleSubmit}>
              <div
                className={classNames({
                  'form-group': true,
                  [styles.error]: errors.name,
                })}
              >
                <label htmlFor="name">Name*</label>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  id="name"
                  onChange={handleChange}
                  value={name}
                />
                <p>Name is required</p>
              </div>
              <div
                className={classNames({
                  'form-group': true,
                  [styles.error]: errors.email,
                })}
              >
                <label htmlFor="email">Email*</label>
                <input
                  name="email"
                  type="email"
                  className="form-control"
                  id="email"
                  onChange={handleChange}
                  value={email}
                />
                <p>Invalid email format</p>
              </div>
              <div className="form-group">
                <label htmlFor="school">School</label>
                <input
                  name="school"
                  type="school"
                  className="form-control"
                  id="school"
                  onChange={handleChange}
                  value={school}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Any Questions?</label>
                <textarea
                  name="message"
                  className="form-control"
                  onChange={handleChange}
                  value={message}
                />
              </div>

              <span className={styles.required}>* Required</span>
              <button
                type="submit"
                className={`${styles.submitButton} btn btn-primary-alt`}
              >
                Submit
              </button>
            </form>
          </div>
        ) : (
          <div className={`${styles.thanksMessage} col-xs-12`}>
            <h2>Thanks for reaching out!</h2>
            <p>We'll get back to you immediately</p>
          </div>
        )}
      </div>
    );
  }
}

const ValidatedMarketingLanding = FormWithValidations(
  MarketingLanding,
  { name: '', email: '', school: '', message: '' },
  validations,
);

export default ValidatedMarketingLanding;
